import React from 'react';
import HeroSlider from '../components/HeroSlider';
import ServicesSection from '../components/ServicesSection';
import PrioritySectionMui from '../components/PrioritySectionMui';
import AboutSection from '../components/AboutSection';
import LatestNewsSection from '../components/LatestNewsSection';
import SellCTASection from '../components/SellCTASection';
import FeaturedPropertiesSection from '../components/FeaturedPropertiesSection';

export default function HomePage() {
  return (
    <>
      <HeroSlider />
      <ServicesSection />
      <FeaturedPropertiesSection />
      <PrioritySectionMui />
      <AboutSection />
      <LatestNewsSection />
      <SellCTASection />
    </>
  );
}
